export const REVIEWS = [
  {
    quote: "Light, sturdy and my 4-year-old actually keeps them on. Worth every rupee.",
    author: "Aanya's mom",
    location: "Bengaluru",
    tone: "#A9CDE5",
  },
  {
    quote: "Survived the beach, the slide and one very angry toddler. Still perfect.",
    author: "Vikram, dad of two",
    location: "Mumbai",
    tone: "#F4C734",
  },
  {
    quote: "The colours are gorgeous. Look like little art pieces on her face.",
    author: "Priyanka R.",
    location: "Delhi",
    tone: "#F0A8C3",
  },
  {
    quote: "Real polarized lenses at this price? Yes please. We have three now.",
    author: "Arjun's dad",
    location: "Pune",
    tone: "#EE8C72",
  },
  {
    quote: "Made my kid feel like the coolest person at the park. Mission accomplished.",
    author: "Kavya M.",
    location: "Hyderabad",
    tone: "#8BC547",
  },
];
